import { render, staticRenderFns } from "./SavedTripsContent.vue?vue&type=template&id=1ec5608f"
import script from "./SavedTripsContent.vue?vue&type=script&lang=ts"
export * from "./SavedTripsContent.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports